import React, { Component, useState, useEffect  } from "react"
import axios from 'axios';

import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Nav,
  TabContent,
  TabPane,
  Label,
  Button,
  Input,
  InputGroup,
} from "reactstrap"

  import { UserContext } from "../../../UserContext";


import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

//Import Breadcrumb
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import Tab1 from "components/Admin/Proceeds/Tab1";
import Tab2 from "components/Admin/Proceeds/Tab2";
import Tab3 from "components/Admin/Proceeds/Tab3";


export const AdminProceedAllocate =()=>{

  const [AdminUserid, setAdminUserid] = React.useState('');
  const [activeTab, setActiveTab] = useState("1")

const{auth,user} = React.useContext(UserContext)


React.useEffect( () => {
    
    if (auth != null) {
      if (!auth) {
        window.location.href="/login"
      }else{
          setAdminUserid(user.user.userid);
      }
    }
  }, [auth])



const updateActiveTab = async(tab) => {
  setActiveTab(tab)
}

    return(
      <React.Fragment>
      <div className="page-content">
      <ToastContainer
            position="top-right"
            autoClose={5000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="dark"
            />

        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumbs title="Crypto" breadcrumbItem="Allocate Proceeds" />

          <Row>

          <Col xl="12">

              <div className="mt-4 mb-3">

               
                    <Tab1 activeTab={activeTab} updateActiveTab={updateActiveTab} />
                    <Tab2 activeTab={activeTab} updateActiveTab={updateActiveTab} AdminUserid={AdminUserid} />
                    <Tab3 activeTab={activeTab} updateActiveTab={updateActiveTab} AdminUserid={AdminUserid} />
   
                </div>

            </Col>

          </Row>

        </Container>
      </div>
    </React.Fragment>
    )
}